export const bexio = {
  oAuthFlowHelp: "Meinen bexio Account autorisieren",
  authSuccess: "Die Autorisierung bei bexio war erfolgreich."
};
